import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(["GET_PRODUCTS_LIST_TRUST", "GET_PRODUCTS_TRUST_SELECTED"]),
    getProductIdChecked() {
      //  if all checked, return '' else return list of ids

      return _.get(this.GET_PRODUCTS_TRUST_SELECTED, 'id');
    },

  },
  methods: {

  },
};
